import React from 'react';
import { FieldArray } from '@framework/ui/Organisms/FinalForm';
import DialInCountriesTable from './DialInCountriesTable';
import { IDialInCountry } from '@evercall/domain/vo/DialInCountry';

interface IProps {
  labelCls?: string,
  tableContainerCls?: string,
  countryList: Array<IDialInCountry>,
  disabled: boolean,
}

const DialInCountriesFieldArray = ({
  labelCls,
  tableContainerCls,
  countryList,
  disabled,
}: IProps) => (
  <>
    <div className={ labelCls }>
      Speakers and Participants Dial-Ins needed (by country)
    </div>
    <FieldArray
      name="dialInCountries"
      containerCls={ tableContainerCls }
      countryList={ countryList }
      disabled={ disabled }
      component={ DialInCountriesTable }
    />
  </>
);
export default DialInCountriesFieldArray;
